// @owners { team: patients }
import { isWebStaging } from './isWebStaging';

type GrowthbookApiKeyProps = {
  env: string;
  production: string;
  staging: string;
  sandbox: string;
};

export const getGrowthbookApiKey = ({ env, production, staging, sandbox }: GrowthbookApiKeyProps) => {
  if (isWebStaging({ backendEnv: env })) {
    return staging;
  }
  switch (env) {
    case 'staging':
      return staging;
    case 'production':
      return production;
    default:
      return sandbox;
  }
};
